import React from 'react';
export function FolderIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 6h-6.279l-.316-.949A3 3 0 009.559 3H5a3 3 0 00-3 3v12a3 3 0 003 3h14a3 3 0 003-3V9a3 3 0 00-3-3zM5 5h4.559a1 1 0 01.948.683l.544 1.633A1 1 0 0012 8h7a1 1 0 011 1v1.184A2.967 2.967 0 0019 10H5c-.341.003-.68.066-1 .184V6a1 1 0 011-1zm15 13a1 1 0 01-1 1H5a1 1 0 01-1-1v-5a1 1 0 011-1h14a1 1 0 011 1v5z"
  }));
}